export const appHasHistory = (entityData) => {
  if (
    entityData?.okta_data?.creation_date ||
    entityData?.okta_data?.last_updated ||
    entityData?.salesforce_data?.creation_date ||
    entityData?.salesforce_data?.last_updated ||
    entityData?.zoom_data?.approved_time ||
    entityData?.google_data?.creation_date ||
    entityData?.google_data?.last_updated_date
  ) {
    return true;
  } else {
    return false;
  }
};

export const appHasUsers = (entityData, userEntities) => {
  if (
    getOktaAppConnectedUsersRows(entityData, userEntities).length > 0 ||
    entityData?.google_data?.user_ids?.length > 0
  ) {
    return true;
  } else {
    return false;
  }
};

export const getOktaAppConnectedUsersRows = (entityData, userEntities) => {
  let rowsMap = [];
  if (!entityData || !userEntities) {
    return rowsMap;
  }
  for (const userEntity of userEntities) {
    const userOktaAppIds = userEntity?.okta_data?.okta_app_unique_ids || [];
    const hasMatchingApp = userOktaAppIds.includes(entityData?.unique_id);
    if (hasMatchingApp) {
      const userSources = userEntity?.sources;
      rowsMap.push({
        id: rowsMap.length + 1,
        userId: userEntity?.unique_id,
        entityObj: userEntity,
        source: userSources ? userSources : [],
      });
    }
  }
  return rowsMap;
};
